import React from 'react';
import { ThemeProvider } from '@mui/system';
import { AlertsContextProvider } from 'contexts/alertsContext';
import { AuthProvider } from 'contexts/authContext';
import { InvoicesContextProvider } from 'contexts/invoicesContext';
import { MessageContextProvider } from 'contexts/messageContext';
import { RatesContextProvider } from 'contexts/ratesContext/ratesContext';
import { TransportCloudContextProvider } from 'contexts/transportCloudContext/transportCloudContext';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { App } from 'root';
import { theme } from 'theme/theme';
import reportWebVitals from './reportWebVitals';
import './i18n';
import './styles/index.css';
import 'react-toastify/dist/ReactToastify.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <Router>
      <ToastContainer theme='colored' pauseOnFocusLoss={false} />
      <AuthProvider>
        <AlertsContextProvider>
          <MessageContextProvider>
            <InvoicesContextProvider>
              <RatesContextProvider>
                <TransportCloudContextProvider>
                  <ThemeProvider theme={theme}>
                    <App />
                  </ThemeProvider>
                </TransportCloudContextProvider>
              </RatesContextProvider>
            </InvoicesContextProvider>
          </MessageContextProvider>
        </AlertsContextProvider>
      </AuthProvider>
    </Router>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
